import { type BasePageParams } from '@/app/urls/url-mapping';
import { type UrlEntry, type UrlRegion } from '@/types';

export const isIndexable = false;

export type QuizFlowParams = { urlSegments: string[] } & BasePageParams;

// In next iteration should use similar approach as author page for i18n slugs
const PREFIXES = ['quiz'] as const;

type Prefix = (typeof PREFIXES)[number];

export type QuizFlowPages = `quizFlow/${Prefix}`;

export const urls: Record<
  QuizFlowPages,
  Partial<Record<UrlRegion, UrlEntry<Prefix>>>
> = {
  'quizFlow/quiz': {
    es: 'quiz',
    'es-en': 'quiz',
    pt: 'quiz',
    'pt-en': 'quiz',
  },
};

export const getQuizFlowPageType = (params: QuizFlowParams): QuizFlowPages => {
  const {
    urlSegments: [prefix],
  } = params;
  return `quizFlow/${prefix}` as QuizFlowPages;
};

export const isQuizFlowPrefix = (segment: string): segment is Prefix =>
  PREFIXES.includes(segment as Prefix);
